/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_membership = {};

(function(){
	 
	/*
	PRELOAD & DOCUMENT READY  *****************************************************************
	PRELOAD & DOCUMENT READY  *****************************************************************
	PRELOAD & DOCUMENT READY  *****************************************************************
	PRELOAD & DOCUMENT READY  *****************************************************************
	*/

	this.onready = function() {
			
		/*
		Click
		*/
		$(document).on('click','.js-membership-toggle',function() {

			/*
			Set: Active
			*/
			$(this).addClass('active');

			/*
			On or off?
			On or off?
			On or off?
			On or off?
			*/
			if($(this).data('option') == 'on') {
				specific_membership.start();
			} else {
				specific_membership.stop();
			}

		});

		/*
		Bankaccount change
		*/
		$(document).on('click','.js-bankaccount-change',function() {
			specific_membership.changeBankaccount();
		});

	};
	
	/*
	METHODS *****************************************************************
	METHODS *****************************************************************
	METHODS *****************************************************************
	METHODS *****************************************************************
	*/
	
	this.start = function() {

		/*
		AJAX
		*/
		$.ajax({
			url: globalUrl + '/a/a/mollie-recurring-first',
			method:'POST',
			data: {
			},
			headers: { 
				'go-load':1 
			},
			success: function(response) {

				/*
				Go to Mollie
				*/
				window.location.href = response;
			  
			}
		});

	};

	this.stop = function() {

		/*
		AJAX
		*/

	};

	/*
	Change: Bankaccount
	*/
	this.changeBankaccount = function() {

		alert(1);

		/*
		AJAX
		*/
		$.ajax({
			url: globalUrl + '/a/a/mollie-bankaccount-change',
			method:'POST',
			data: {
			},
			headers: { 
				'go-load':1 
			},
			success: function(response) {

				/*
				Go to Mollie
				*/
				window.location.href = response;
			  
			}
		});

	};

}).apply(specific_membership); 